"use client";

import { CHANGE_PASSWORD_FORM_FIELDS } from "@repo/constants/account";
import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useFormValidation } from "@repo/lib/hooks/common";
import { validation } from "@repo/lib/utils";
import { updatePassword } from "@repo/server-actions/account";
import { Button, ErrorMessage, InputPassword, LoadingDots } from "@repo/ui";
import { useTranslations } from "next-intl";
import { useTransition } from "react";
const formFields = {
  oldPassword: "",
  newPassword: "",
  confirmNewPassword: ""
};
const ChangePasswordForm = ({
  session,
  toggleChangePassword
}) => {
  const t = useTranslations("Common");
  const {
    setSnackbar
  } = useSnackbarContext();
  const [isPending, startTransition] = useTransition();
  const {
    formValues,
    formErrors,
    setFormErrors,
    handleValidation
  } = useFormValidation(formFields);
  const sumbitForm = async () => {
    startTransition(async () => {
      const response = await updatePassword(formValues, session);
      setSnackbar({
        open: true,
        message: response?.message,
        type: response?.success ? "success" : "error"
      });
      if (response?.success) toggleChangePassword();
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    const errors = validation(formValues, t);
    if (Object.keys(errors).length === 0) {
      sumbitForm();
    } else {
      setFormErrors(errors);
      console.log("Failed to submit the form, please check the form fields");
    }
  };
  return <form onSubmit={handleSubmit} className="p-4" data-sentry-component="ChangePasswordForm" data-sentry-source-file="ChangePasswordForm.jsx">
      <div className="flex flex-wrap">
        {CHANGE_PASSWORD_FORM_FIELDS?.map(field => <div key={field.id} className="mb-4 w-full">
            {field.type === "input" && <InputPassword name={field.name} placeholder={t(field.placeholder)} value={formValues?.[field.name]} onChange={handleValidation} readOnly={field.readOnly} disabled={field.disabled} label={t(field.label)} />}
            <ErrorMessage message={formErrors?.[field.name]} />
          </div>)}
      </div>
      <div className="text-center md:text-end">
        <Button size="md" type="submit" variant="primary" disabled={isPending} className="w-full" data-sentry-element="Button" data-sentry-source-file="ChangePasswordForm.jsx">
          {isPending ? <LoadingDots className="bg-white" /> : t("Update")}
        </Button>
      </div>
    </form>;
};
export default ChangePasswordForm;